// shared/ui/autocompleteSx.js  (estilo compartido de los Autocomplete MUI de la feature)

// Misma altura (44px) que ReactHookFormInput y CatalogSelect; MUI medium mide 56px (53px con el padding del Autocomplete).
// Solo se quita el padding vertical: el horizontal se conserva. El adorno final de MUI ya se centra (top: calc(50% - 14px)).
export const autocompleteFieldSx = {
  '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
    height: 44,
    paddingTop: 0,
    paddingBottom: 0,
    alignItems: 'center',
    '& .MuiAutocomplete-input': { paddingTop: 0, paddingBottom: 0 },
  },
  // La etiqueta sin encoger (translate 16px) asume 56px de alto; a 44px se centra con 12px.
  '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { transform: 'translate(14px, 12px) scale(1)' },
};

// Select MUI a 44px `.MuiSelect-select`
export const selectFieldSx = {
  '& .MuiSelect-select.MuiInputBase-input': {
    boxSizing: 'border-box',
    height: 44,
    minHeight: 44,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: '14px',
    paddingRight: '32px',
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    lineHeight: 1.4375,
  },
  '& .MuiInputAdornment-root + .MuiSelect-select.MuiInputBase-input': { paddingLeft: 0 },
  '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': { transform: 'translate(14px, 12px) scale(1)' },
};
